export const HOMEPAGE_FILTER_AUTOMATION_IDS = {
  bedsDropdown: 'homepage-beds-dropdown',
  bedsDoneButton: 'homepage-beds-done-button',
  bedsTrigger: 'homepage-beds-trigger',
  priceDropdown: 'homepage-price-dropdown',
  priceDoneButton: 'homepage-price-done-button',
  priceMaxInput: 'homepage-price-max-input',
  priceMinInput: 'homepage-price-min-input',
  priceTrigger: 'homepage-price-trigger',
  resetFiltersLink: 'homepage-reset-filters-link',
  searchButton: 'homepage-search-button',
  summary: 'homepage-filter-summary',
} as const;
